export default __webpack_public_path__ + "static/media/img-proj-om-wallet.933a2435.png";